import { FC, useRef } from "react";
import styled from 'styled-components/macro';
import useDropdown from "../../../hooks/useDropdown";
import info from '../../../assets/icons/info-circle-solid.svg';

interface TooltipProps {
    optionDescription?: string;
    isMobile?: boolean;
    onClick?: () => void;
    isCustomSizeIcon?: boolean;
}


const TooltipContainer = styled.div`
    position: absolute;
    right: 2px;
    top: 5px;
    z-index: 3;
    text-align: center;
    cursor: pointer;
`;

const InfoIcon = styled.img<{ isMobile?: boolean, isCustomSizeIcon?: boolean }>`
    height: 17px;
    width: 17px;
    ${props => props.isCustomSizeIcon && `cursor: pointer`};
`;

const OptionDescription = styled.div`
    width: auto;
    padding: 5px;
`;

export const Tooltip: FC<TooltipProps> = ({ optionDescription: text, isMobile, onClick, isCustomSizeIcon }) => {
    const [open, close, isOpened, Dropdown] = useDropdown();
    const ref = useRef<HTMLImageElement>(null);

    return <TooltipContainer>
        {isMobile
            ? <InfoIcon
                ref={ref}
                isMobile={isMobile}
                onClick={() => onClick ? onClick() : () => open(ref.current!, 'top', 'left', true)}
                src={info} />
            : <InfoIcon
                ref={ref}
                isMobile={isMobile}
                onClick={() => onClick ? onClick() : () => null}
                onMouseEnter={isCustomSizeIcon ? () => null : () => open(ref.current!, 'top', 'left', true)}
                onMouseLeave={isCustomSizeIcon ? () => null : () => close()}
                src={info} />}
        {isOpened && <Dropdown>
            <OptionDescription>{text}</OptionDescription>
        </Dropdown>}
    </TooltipContainer>;
}

export default Tooltip;